import smoothscroll from 'smoothscroll-polyfill';

document.addEventListener('DOMContentLoaded', () => {
  smoothscroll.polyfill();

  document.querySelectorAll('.partners .slider').forEach((slider) => {
    const sliderWrapper = slider.querySelector('.slider-wrapper');

    slider.querySelector('.arrow.left').addEventListener('click', () => {
      const { width } = sliderWrapper.getBoundingClientRect();
      const scrollLeft = Math.max(sliderWrapper.scrollLeft - width, 0);

      sliderWrapper.scrollTo({
        top: 0,
        left: scrollLeft,
        behavior: 'smooth',
      });
    });

    slider.querySelector('.arrow.right').addEventListener('click', () => {
      const { width } = sliderWrapper.getBoundingClientRect();
      const scrollLeft = Math.max(sliderWrapper.scrollLeft + width, width);

      sliderWrapper.scrollTo({
        top: 0,
        left: scrollLeft,
        behavior: 'smooth',
      });
    });
  });
});
